export default "<div [@slideIn]>\r\n    <router-outlet></router-outlet>\r\n</div>\r\n";